import axios from "axios";

export default axios.create({
   baseURL: 'https://insighture.rnd.kekayan.dev',
});
